import { IconProps } from "../../utils/global-types/global-types";

const CollapseArrowIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="m10.326 12.886 3.62-6.417a1.37 1.37 0 0 0-.01-1.374 1.32 1.32 0 0 0-1.15-.665h-7.24a1.32 1.32 0 0 0-1.148.665 1.37 1.37 0 0 0-.01 1.374l3.62 6.417a1.325 1.325 0 0 0 2.318 0"
    ></path>
  </svg>
);

export default CollapseArrowIcon;
